import { render, staticRenderFns } from "./dynamics.vue?vue&type=template&id=62a93224&scoped=true"
import script from "./dynamics.vue?vue&type=script&lang=js"
export * from "./dynamics.vue?vue&type=script&lang=js"
import style0 from "./dynamics.vue?vue&type=style&index=0&id=62a93224&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62a93224",
  null
  
)

export default component.exports